import { z } from 'zod'

// Dan provides Drug Products to the app through the offline data set.
// His definition:
// "Drug products are products by a company you can purchase, like Tylenol
// or what not [...] they're not ingredients or the base component of the
// drug, but a purchasable item"
export const RDrugProduct = z.object({
	ID: z.number(),
	Name: z.string(),
})
export type DrugProduct = z.infer<typeof RDrugProduct>

export const RIndication = z.object({
	Icd10Code: z.string(),
	Description: z.string(),
	// TODO [ISSUE-1520]
	// This property should signify wether or not the indication was
	// automatically suggested to the clinician before they added it.
	// As a reminder, in Med Recon v2, some indications will be automatically
	// suggested for a given drug when the clinician pops up the indication
	// modal.  If one of those indications is added it should be recorded as
	// IsManual: false.  If the clinician enters a query into the modal's
	// text search, and adds an indication that was not originally suggested,
	// it should be recorded as IsManual: true.
	// This flag has no effect in the current UI, but Denise notes it could
	// potentially be interesting later for figuring out if a particular
	// indication gets added manually a lot to a particular drug.
	IsManual: z.optional(z.boolean()),
})
export type Indication = z.infer<typeof RIndication>

export enum DrugConfirmation {
	Scan = 'SCAN',
	ManualEntry = 'MANUAL_ENTRY',
}

export const RPrescription = z.object({
	Product: RDrugProduct,
	Indications: z.array(RIndication),
	// null = clinician has not answered; this will be required
	InUse: z.nullable(z.boolean()),
	IsPrior: z.boolean(),
	Confirmation: z.nullable(z.enum(DrugConfirmation)),
	Reason: z.nullable(z.string()),
})
export type Prescription = z.infer<typeof RPrescription>
